import AppContext from 'context';
import { TTruckerItem } from 'context/reducers/truckers.type';
import { useContext, useEffect, useState } from 'react';
import { fnSort } from 'utils/fnSort';

const PRIVATE_PERSON = 1;
const JURIDICAL_PERSON = 2;

export const useFilteredData = () => {
  const {
    state: {
      truckers: { truckerType, vehicles, areaCodes, sort },
      suggestedTruckers: { dataSuggested },
      tabs: { activeTab },
    },
  } = useContext(AppContext);

  const [filteredDataSuggested, setFilteredDataSuggested] = useState<TTruckerItem[]>([]);
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);

  const shouldFilterPF = truckerType?.includes('pf') && !truckerType?.includes('pj');
  const shouldFilterPJ = truckerType?.includes('pj') && !truckerType?.includes('pf');
  const shouldFilterPermission = truckerType?.includes('hasPermission');

  const sortFn = fnSort[sort as keyof typeof fnSort];
  const filterPf = (item: TTruckerItem) => item.vehicle.ownerType === PRIVATE_PERSON;
  const filterPj = (item: TTruckerItem) => item.vehicle.ownerType === JURIDICAL_PERSON;
  const filterPermission = (item: TTruckerItem) => item.hasPermission;

  const filterAndSortData = (data: TTruckerItem[]) => {
    let aux = [...data];
    if (!!vehicles?.length) {
      aux = aux.filter((item: TTruckerItem) => vehicles.includes(item.vehicle.type));
    }

    if (!!areaCodes?.length) {
      aux = aux.filter((item: TTruckerItem) => areaCodes.some((codes) => item.person.areaCodes?.includes(codes)));
    }

    if (!!truckerType?.length) {
      const filteredPf = aux.filter((item) => shouldFilterPF && filterPf(item));
      const filteredPj = aux.filter((item) => shouldFilterPJ && filterPj(item));
      const filteredHasPermission = aux.filter((item) => shouldFilterPermission && filterPermission(item));

      aux = [...filteredPf, ...filteredPj, ...filteredHasPermission];
    }

    if (!!sort) aux = aux.sort(sortFn);

    return aux;
  };

  const setData = (data: TTruckerItem[], setFn: (rawData: TTruckerItem[]) => void) => {
    if (!!!data?.length) {
      setFn([]);
      return;
    }

    if (!!data?.length && !isFiltersApplied) {
      setFn(data);
      return;
    }

    if (!!data?.length && isFiltersApplied) {
      setFn(filterAndSortData(data));
    }
  };

  useEffect(() => {
    setIsFiltersApplied(!!sort || !!truckerType?.length || !!vehicles?.length || !!areaCodes?.length);
  }, [sort, truckerType, vehicles, areaCodes]);

  useEffect(() => {
    setData(dataSuggested, setFilteredDataSuggested);
  }, [dataSuggested, activeTab, isFiltersApplied, sort, truckerType, vehicles, areaCodes]);

  return { filteredDataSuggested, isFiltersApplied };
};
